import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Icon } from 'semantic-ui-react';
import styled from 'styled-components';
import update from 'react-addons-update';

import { SortableContainer, SortableElement, arrayMove } from 'react-sortable-hoc';
import { SortableItem } from '../StaffManagement';
import CommonModal from './Modal/CommonModal';
import toastr from '../../helpers/toastr';

const SortableList = SortableContainer(
  ({
    items,
    childUserCnts,
    itemsChange,
    divisionClick,
    divisionStaffSel,
    divisionMod,
    divisionAdd,
    divisionDel,
    divisionAscending,
    isLoadingBarChange,
    divisionUserCntSel,
    modal,
    orgCodeChange,
    orgCodePut,
    orgCodes,
    selectedOrgCode,
    itemWidth
  }) => {
    return (
      <ItemList2>
        {items.map((value, index) => {
          let userCnt = null;
          if (childUserCnts) {
            childUserCnts.some((item) => {
              if (item.orgCode === value.orgCode) {
                userCnt = item.userCnt;
                return true;
              }
            });
          }
          return (
            <SortableItem
              key={`item-${index}`}
              userCnt={userCnt}
              childUserCnts={childUserCnts}
              index={index}
              value={value}
              divisionClick={divisionClick}
              divisionStaffSel={divisionStaffSel}
              divisionMod={divisionMod}
              divisionAdd={divisionAdd}
              divisionDel={divisionDel}
              divisionAscending={divisionAscending}
              isLoadingBarChange={isLoadingBarChange}
              divisionUserCntSel={divisionUserCntSel}
              modal={modal}
              orgCodeChange={orgCodeChange}
              orgCodePut={orgCodePut}
              orgCodes={orgCodes}
              selectedOrgCode={selectedOrgCode}
              itemWidth={itemWidth}
            />
          );
        })}
      </ItemList2>
    );
  }
);

class SortableDivision extends Component {
  state = {
    items: this.props.items,
    userCnts: this.props.userCnts,
    selectedOrgCode: null,
    isAllClick: true,
    childUserCnts: this.props.divisionUserCnt ? this.props.divisionUserCnt : null,
    parentOrgCode: this.props.parentOrgCode ? this.props.parentOrgCode : null
  };

  async componentWillMount() {
    const { childUserCnts } = this.state;

    if (!childUserCnts) {
      await this.props.divisionUserCntSel();
      // 조회 응답이 도착하기 전에 화면을 벗어났으면 setState 하지 않는다.
      if (this.unmounted) return;
      await this.setState({
        childUserCnts: this.props.divisionUserCnt ? this.props.divisionUserCnt : null
      });
    }
    this.divisionOpen();
  }

  componentDidMount() {
    const itemWidth = document.querySelector('.ui.bottom.attached.segment').offsetWidth;
    this.setState({
      itemWidth: itemWidth
    });
  }

  async shouldComponentUpdate(nextProps, nextState) {
    const { selectedOrgCode, items, userCnts, divisionUserCnt } = this.props;
    const { childUserCnts } = this.state;
    const selectedOrgCodeIsChange = nextProps.selectedOrgCode !== selectedOrgCode;
    const changeUserCnt = childUserCnts !== nextState.childUserCnts;
    return !selectedOrgCodeIsChange || changeUserCnt;
  }

  componentWillUnmount() {
    this.unmounted = true;
  }

  onSortEnd = ({ oldIndex, newIndex }) => {
    const { items } = this.state;
    const { parentOrgCode, divisionMod } = this.props;
    const sort = [];
    items.forEach((data) => {
      sort.push(data.orgCode);
    });

    this.setState({
      items: arrayMove(this.state.items, oldIndex, newIndex)
    });

    const id = sort[oldIndex];
    let num = 0;
    let spliceNum = 1;
    if (oldIndex < newIndex) {
      num = 1;
      spliceNum = oldIndex;
    } else {
      num = 0;
      spliceNum = oldIndex + 1;
    }
    sort.splice(newIndex + num, 0, sort[oldIndex]);
    sort.splice(spliceNum, 1);

    const params = {
      id,
      sort: {
        parentOrgCode: parentOrgCode,
        orgCode: sort
      }
    };
    divisionMod(params);
  };

  /**
   * [부서 뎁스 클릭]
   * @param  {[object]}  item [현재 부서 리스트]
   * @param  {[String]}  type [click, del]
   * @return {Promise}      [description]
   */
  divisionClick = async (item, type) => {
    const {
      orgCodeChange,
      divisionStaffSel,
      orgCodePut,
      divisionUserCntSel,
      divisionUserCnt,
      isLoadingBarChange
    } = this.props;
    isLoadingBarChange(item.isHaveChild);
    const { parentOrgCode } = this.state;
    let idx = null;
    let orgCode = null;
    let depth = 0;

    if (type === 'del') {
      orgCode = parentOrgCode;
      depth = item[0].depth - 1;
    } else {
      orgCode = item.orgCode;
      depth = item.depth;
    }
    if (item.depth === 1 || item.isHaveChild) {
      if (item.isHaveChild) {
        await divisionUserCntSel({ orgCode });
      }
      await divisionStaffSel(orgCode);
    }
    await orgCodeChange(orgCode, depth, item.isHaveChild);

    this.setState({
      selectedOrgCode: orgCode,
      childUserCnts: divisionUserCnt
    });
    await orgCodePut(orgCode, depth);
    this.divisionOpen('click');
  };

  allCheck = async () => {
    const { divisionStaffSel, orgCodePut, orgCodes } = this.props;
    const { items } = this.state;

    this.setState({
      selectedOrgCode: null
    });
    await orgCodePut(null, 0);
    items.forEach(async (item, index) => {
      await this.setState({
        items: update(this.state.items, {
          [index]: {
            isOpen: { $set: false }
          }
        })
      });
    });
    this.setState({
      isAllClick: true
    });
    divisionStaffSel(null);
  };

  divisionMod = (params, type) => {
    const { divisionMod, divisionAdd, divisionDel, divisionAscending, modal } = this.props;
    const { items, selectedOrgCode } = this.state;
    // 서버 통신 전에 부서명 존재여부 체크 (삭제인 경우는 제외)
    if (type === 'add' || type === 'mod') {
      if (params.name === null) {
        toastr('top-right', 'error', '부서명을 입력해주세요.');
        return;
      }
    }
    if (type === 'add') {
      divisionAdd(params);
    } else if (type === 'del') {
      divisionDel(params);
      this.divisionClick(items, 'del');
    } else if (type === 'ascending') {
      // 부서명으로 오름차순 정렬한다.
      items.sort(function(a, b) {
        return a.name < b.name ? -1 : a.name > b.name ? 1 : 0;
      });

      let divisionInfo = {};
      let orgCodeLst = [];

      for (let inx = 0; inx < items.length; inx++) {
        orgCodeLst.push(items[inx].orgCode);
      }

      divisionInfo.sort = {};
      divisionInfo.sort.orgCode = orgCodeLst;
      divisionAscending(divisionInfo);
    } else {
      items.some((item, index) => {
        if (item.orgCode === selectedOrgCode) {
          this.setState({
            items: update(this.state.items, {
              [index]: {
                name: { $set: params.name }
              }
            })
          });
        }
      });
      divisionMod(params);
    }

    modal.close();
  };

  divisionOpen = async (type) => {
    const { orgCodes, orgCodePut, divisionUserCntSel, divisionUserCnt } = this.props;
    const { items, selectedOrgCode, parentOrgCode } = this.state;
    let result = true;
    let params = null;
    let userCnts = null;

    if (orgCodes.length > 0) {
      items.some((item, index) => {
        if (item.orgCode === orgCodes[item.depth - 1]) {
          this.setState({
            items: update(this.state.items, {
              [index]: {
                isOpen: { $set: !item.isOpen }
              }
            }),
            selectedOrgCode: item.orgCode
          });
          params = { orgCode: item.orgCode };
        } else {
          if (type === 'click') {
            this.setState({
              items: update(this.state.items, {
                [index]: {
                  isOpen: { $set: false }
                }
              })
            });
          }
        }
      });
    }
  };

  render() {
    const {
      modal,
      orgCodePut,
      orgCodes,
      divisionMod,
      divisionAdd,
      divisionDel,
      divisionUserCntSel,
      isLoadingBarChange,
      divisionUserCnt,
      userCnts,
      userTotal
    } = this.props;
    const { selectedOrgCode, items, isAllClick, childUserCnts, itemWidth } = this.state;
    return (
      <ContentWrapper2 depth={items[0].depth === 1}>
        {items[0].depth === 1 ? (
          <ItemDiv2
            className="line"
            onClick={this.allCheck}
            selectedOrgCode={selectedOrgCode}
            isAllClick={isAllClick}
            itemWidth={itemWidth}
          >
            <Icon disabled name="minus" style={{ fontSize: '24px', margin: '0 0 -5px 5px' }} />
            <span>{`전체(${userTotal})`}</span>
          </ItemDiv2>
        ) : null}
        {
          <SortableList
            // pressDelay={300}
            items={items}
            childUserCnts={childUserCnts}
            onSortEnd={this.onSortEnd}
            divisionClick={this.divisionClick}
            divisionStaffSel={this.props.divisionStaffSel}
            divisionMod={this.props.divisionMod}
            divisionAdd={divisionAdd}
            divisionDel={divisionDel}
            isLoadingBarChange={isLoadingBarChange}
            divisionUserCntSel={divisionUserCntSel}
            orgCodeChange={this.props.orgCodeChange}
            orgCodePut={orgCodePut}
            orgCodes={orgCodes}
            modal={modal}
            selectedOrgCode={selectedOrgCode}
            itemWidth={itemWidth}
            useDragHandle={true}
          />
        }
        {selectedOrgCode === modal.openModalOrgCode ? (
          <CommonModal orgCode={selectedOrgCode} fn={null} modal={modal} divisionFunc={this.divisionMod} />
        ) : null}
      </ContentWrapper2>
    );
  }
}

const ItemDiv2 = styled.div`
  height: 40px;
  display: flex;
  padding-left: 5px;
  border-top: 1px solid #efefef;
  border-bottom: 1px solid #efefef;
  align-items: center;
  border-bottom: 1px solid #efefef;
  z-index: 999;
  cursor: pointer;
  width: ${(props) => props.itemWidth + 'px'};
  background: ${(props) => (props.isAllClick && !props.selectedOrgCode ? '#0bb656' : '#ffffff')};
  color: ${(props) => (props.isAllClick && !props.selectedOrgCode ? '#ffffff' : null)};
`;

const ContentWrapper2 = styled.div`
  display: table;
  width: 100%;
  & > div > em {
    display: block;
  }
  border-bottom: ${(props) => (props.depth ? '1px solid #efefef' : null)};
`;
const ItemList2 = styled.div``;

const ContentWrapper = styled.div`
  display: table;
  margin: 0 auto;

  & > div > em {
    display: block;
    max-width: 320px;
    margin-bottom: 20px;
    text-align: center;
    font-family: Helvetica Neue, Helvetica, Arial, sans-serif;
    color: #888;
    -webkit-font-smoothing: antialiased;
    font-size: 15px;
    line-height: 1.3;
    font-style: normal;

    a {
      color: inherit;
    }
  }
`;
const ItemList = styled.div`
  position: relative;
  z-index: 0;
  background-color: #f3f3f3;
  border: 1px solid #efefef;
  border-radius: 3px;
  outline: none;
  width: auto;
  height: auto;
  min-width: 305px;
  max-height: 427px;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  border: 1px solid #999;
`;
SortableDivision = connect((state) => ({
  divisionUserCnt: state.company.divisionUserCnt //부서별 사용자 수(카운트)
}))(SortableDivision);
export default SortableDivision;
